import React, { useState } from 'react';
import { config } from '../config';
import { I18nextProvider } from 'react-i18next';
import { generateTheme } from '@fmc-digital/ui';
import { ThemeProvider } from '@mui/material';
import { OnBoardingContainer, i18n } from '@fmc-digital/servicing';
import { localStorageHelper } from '@utils/localStorageHelpder';
import { logApiEvent, logUserEvent } from '@analytics/amplifyLogging';
import { useSelector } from 'react-redux';
import { getDurationsInDays, getOnboardingAppFeatureFlags } from '@store/reducers/config.reducer';
import { auth } from 'config';
import { useNavigate } from 'react-router-dom';
import { selectLoanNumberSelected, selectOnboardingCards, selectUserInfo } from '@store/selectors/widgets.selectors';
import { activityEventUpdate, EventLog } from 'fmc-digital-common';
import { useQueryClient } from '@tanstack/react-query';

const Onboarding = ({ path = '' }: { path?: string }) => {
    const token = auth.getOkta().getAccessToken();
    const userInfoSelector = useSelector(selectUserInfo);
    const onboardingFeatureFlags = useSelector(getOnboardingAppFeatureFlags);
    const loanNumber = useSelector(selectLoanNumberSelected);

    const onboardingCardsList = useSelector(selectOnboardingCards(onboardingFeatureFlags, 'welcome-onboarding'));

    const durationsInDays = useSelector(getDurationsInDays);

    const [showOnboarding, setShowOnboarding] = useState(true);

    const queryClient = useQueryClient();

    const navigate = useNavigate();
    const onRedirectToDashboard = async () => {
        setShowOnboarding(false);
        await queryClient.invalidateQueries({ queryKey: ['widgets'] });
        navigate(`/${path}`);
    };

    const onError = () => {
        console.log('error'); // Need to be changed when mfa api integration completed
    };

    const updateActivityEvent = (activityData: any) => {
        const url = config.env('activityUpdateUrl');
        activityEventUpdate(activityData, url);
    };

    const updateLogApiEvent = (config: EventLog) => {
        const updatedLog = Object.assign({}, config, { loanNumber: loanNumber });
        logApiEvent(updatedLog);
    };

    return (
        showOnboarding &&
        onboardingCardsList?.length > 0 && (
            <I18nextProvider i18n={i18n}>
                <ThemeProvider theme={generateTheme()}>
                    <OnBoardingContainer
                        cards={onboardingCardsList}
                        returnToDashboard={onRedirectToDashboard}
                        onError={onError}
                        mobileNumber={userInfoSelector?.mobile}
                        showBackdrop={false}
                        metadata={{
                            tcpaUrl: config.env('tcpaUrl'),
                            paperlessUrl: config.env('paperlessUrl'),
                            triggerMfaUrl: config.env('triggerMfaUrl'),
                            validateMfaUrl: config.env('validateMfaUrl'),
                            accessToken: token,
                            loanNumber: '34535',
                            xApiKey: config.env('xApiKey'),
                            userName: 'user'
                        }}
                        localStorageHelper={localStorageHelper}
                        // userId={userInfo.userUUID}
                        durationInDays={durationsInDays}
                        logUserEvent={logUserEvent}
                        logApiEvent={updateLogApiEvent}
                        showMFA={onboardingFeatureFlags['onboardingWithMFA']}
                        updateActivityEvent={updateActivityEvent}
                    />
                </ThemeProvider>
            </I18nextProvider>
        )
    );
};

export default React.memo(Onboarding);
